import { Box, Container } from '@mui/material'
import { Loader, useMinimalsTheme } from '@tom-ui/ui'
import { appStore, PATHS, useAsyncFetch, useFormStore, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router'
import { useYardStores } from '../../AppProvider'
import { PierFormHeader } from './components/molecules/PierFormHeader'
import { PierForm } from './components/organisms/PierForm'
import { usePierMessageHandler } from './hooks/usePierMessageHandler'
import { PierFormData } from './models/pier.model'

export const PierFormPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()
    const { pierStore } = useYardStores()
    const formStore = useFormStore<PierFormData>()
    const { getExceptionMessage, getSuccessMessage } = usePierMessageHandler()

    const pierId = id ?? null
    const isEdit = !!pierId && pierId !== 'new'

    const { loading } = useAsyncFetch(async () => {
      await pierStore.loadPiers()
    }, [pierStore])

    const selectedPier = isEdit ? pierStore.items.find(x => x.id === pierId) : undefined

    const onSubmit = async () => {
      try {
        if (formStore.validate()) {
          if (isEdit) {
            await pierStore.updatePier({ id: pierId, name: formStore.data.name })
          } else {
            await pierStore.createPier({ name: formStore.data.name })
          }

          appStore.setShowAlert('success', getSuccessMessage(isEdit))
          navigate(PATHS.config.piers.url)
        }
      } catch (error) {
        appStore.setShowAlert('error', getExceptionMessage(error))
      }
    }

    if (loading) return <Loader show />

    return (
      <Box sx={{ bgcolor: theme.palette.grey[100], minHeight: '100%' }}>
        <PierFormHeader isEdit={isEdit} onSubmit={onSubmit} />
        <Container sx={{ paddingY: 2 }}>
          <PierForm formStore={formStore} pier={selectedPier} />
        </Container>
      </Box>
    )
  }),
)
